import { requireGuest } from '@portal/features/auth/guards'
import LandingPage from '@portal/features/landing/LandingPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  beforeLoad: requireGuest,
  component: LandingPage,
})
